import type { InventoryListFilterValue } from "@slfinrtl/ui-bff-routes"
import type { AnalyticsEventCategory } from "src/components/adobeAnalytics"

export const trackingEventMap: Record<keyof InventoryListFilterValue, AnalyticsEventCategory> = {
	accidentFree: "inventory_accident_free",
	bodyTypes: "inventory_body_design",
	dealershipIds: "inventory_location",
	derivatives: "inventory_derivatives",
	driveTrains: "inventory_drive_trains",
	enginePowerUnit: "inventory_engine_power_unit",
	engineTypes: "inventory_engine_types",
	equipmentTags: "inventory_equipment",
	exteriorColors: "inventory_exterior_color",
	interiorColors: "inventory_interior_color",
	listingQuality: "inventory_listing_quality",
	listingVisibility: "inventory_visibility",
	maxFirstRegistrationDate: "inventory_max_first_registration_date",
	maxMileage: "inventory_max_mileage",
	maxModelYear: "inventory_max_model_year",
	maxPrice: "inventory_max_price",
	minEnginePower: "inventory_min_engine_power",
	minFirstRegistrationDate: "inventory_min_first_registration_date",
	minModelYear: "inventory_min_model_year",
	modelGenerations: "inventory_model_generations",
	modelSeries: "inventory_model_series",
	onlineOrderableStatus: "inventory_online_orderable",
	previousOwners: "inventory_previous_owners",
	salesStatus: "inventory_sales_status",
	search: "inventory",
	stockStatus: "inventory_status",
	transmissions: "inventory_transmissions",
	vatDeductible: "inventory_vat_deductible",
	vehicleTypes: "inventory_vehicle_type",
}
